import "react-multi-date-picker/styles/layouts/prime.css";
import { debounce } from "lodash";
import useInput from "hooks/use-input";
import axios from "axios";
import { useState, useEffect } from "react";
import Select, { StylesConfig } from "react-select";
import { connection } from "utils/apiConnection.ts";
function AddCampain({ setUpdater, updater }) {
  const [otherInfo, setOtherInfo] = useState({
    cat_id: [],
    line_id: [],
    subline_id: [],
  });
  const [allProductTags, setAllProductTags] = useState([
    { value: "55", label: "jj" },
  ]);
  const [allLeader, setAllLeader] = useState([]);
  const [filterCat, setFilterCat] = useState();
  const [filterLine, setFilterLine] = useState();
  const title = useInput((value) => value.trim() !== "");
  const options = [
    { value: "1", label: "همکاری در فروش" },
    { value: "2", label: "ارجاع" },
    { value: "3", label: "عضو شدن" },
    { value: "4", label: "بازدید" },
    { value: "5", label: "خرید" },
    { value: "6", label: "کامنت محصول" },
    { value: "7", label: "کامنت سفارش" },
  ];
  const [searchItem, setSearchItem] = useState({ data: [] });
  const [searchBuss, setSearchBuss] = useState({ data: [] });
  const getProducts = (value) => {
    let formData = new FormData();
    formData.append("keyword", value);

    axios
      .post("http://old-sabadib.tatdemo.ir/superadminapi/get_list_product", formData)
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          setSearchItem(
            // res.data.data
            res.data.list.map((val, ind) => ({
              label: val.title,
              value: ind,
            }))
          );
        }
      });
  };
  const handler = debounce((value, action) => {
    if (action.action === "input-change") {
      getProducts(value);
    }
  }, 1000);
  useEffect(() => {
    getProducts("");
  }, []);
  const getBussiness = (value) => {
    let formData = new FormData();
    formData.append("keyword", value);

    axios
      .post("http://old-sabadib.tatdemo.ir/superadminapi/getsuppliers", formData)
      .then((res) => {
        // console.log(res);
        if (res.status === 200) {
          setSearchBuss(
            // res.data.data
            res.data.data.map((val, ind) => ({
              label: val.info.title,
              value: ind,
            }))
          );
        }
      });
  };
  const handlerBuss = debounce((value, action) => {
    if (action.action === "input-change") {
      getBussiness(value);
    }
  }, 1000);
  useEffect(() => {
    getBussiness("");
  }, []);

  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );
      let allProductTags = [];
      for (let index = 0; index < data.lines.length; index++) {
        let newObject = {};
        newObject.value = data.lines[index].id;
        newObject.label = data.lines[index].title;
        newObject.main_cat = data.lines[index].main_cat;
        newObject.parent_line_id = data.lines[index].parent_line_id;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
    }
    loadPage();
  }, []);
  function inputChangeHandlerDaste(option) {
    let temp = {};
    setOtherInfo((prev) => {
      temp = { ...prev };
      temp.cat_id = option;
      return { ...temp };
    });
    // console.log("mainCat",temp.cat_id.value);
    setFilterCat(temp.cat_id.value);
  }
  useEffect(() => {
    async function loadPage() {
      let data = await connection(
        "superadminapi/get_add_edit_product_data",
        {}
      );
      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject.value = [index];
        newObject.label = data.cats[index];
        allLeader.push(newObject);
      }
      setAllLeader(allLeader);
    }
    loadPage();
  }, []);
  const changeHandleraTags = (option) => {
    let temp = {};
    setOtherInfo((prev) => {
      temp = { ...prev };
      temp.line_id = option;
      return { ...temp };
    });
    setFilterLine(temp.line_id);
    // console.log(temp.line_id);
  };
  const changeHandleraSubLines = (option) => {
    setOtherInfo((prev) => {
      let temp = { ...prev };
      temp.subline_id = option;
      return { ...temp };
    });
  };

  const test = allProductTags.filter((item) => {
    if (item.main_cat == filterCat && item.parent_line_id == 0) {
      return item;
    }
  });
  // console.log("cat", test);
  const essen = () => {
    let x = filterLine;
    if (x != undefined) {
      return x.value;
    } else {
      // return console.log("err");
    }
  };

  // console.log("essen", essen());
  const subLine = allProductTags.filter((item) => {
    if (item.parent_line_id == essen()) {
      return item;
    }
  });
  // console.log("subline", subLine);

  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalAdd`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header ">
              <h5 className="modal-title" id="edit-userLabel">
                اضافه کردن تنطیمات
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="shop-setting w-100">
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    نوع :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      options={options}
                      // options={tagsOptions}
                      isMulti={true}
                      style={{ background: "#ddd" }}
                      // value={defaultTags}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label className="form-label mx-2" style={{ width: "110px" }}>
                    دسته بندی :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      className=" filterSelect w-100 "
                      options={allLeader}
                      value={otherInfo.cat_id}
                      onChange={inputChangeHandlerDaste}
                      isMulti={false}
                      style={{ background: "#ddd" }}
                      name="cat_id"
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    لاین :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      options={test}
                      value={otherInfo.line_id}
                      onChange={changeHandleraTags}
                      // options={tagsOptions}
                      isMulti={false}
                      style={{ background: "#ddd" }}
                      // value={defaultTags}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label className="form-label mx-2" style={{ width: "110px" }}>
                    ساب لاین :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      options={subLine}
                      value={otherInfo.subline_id}
                      onChange={changeHandleraSubLines}
                      isMulti={false}
                      style={{ background: "#ddd" }}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    شهر :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      // options={tagsOptions}
                      isMulti={true}
                      style={{ background: "#ddd" }}
                      // value={defaultTags}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    کالا :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      style={{ background: "#ddd" }}
                      options={searchItem}
                      onInputChange={handler}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    عرضه کننده :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <Select
                      id="tags"
                      className=" filterSelect w-100 "
                      style={{ background: "#ddd" }}
                      options={searchBuss}
                      onInputChange={handlerBuss}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-baseline mb-3 w-100">
                  <label
                    htmlFor="shop-main_admin_uid"
                    className="form-label mx-2"
                    style={{ width: "110px" }}
                  >
                    سقف :
                  </label>
                  <div className="w-100" style={{ width: "100% !important" }}>
                    <input
                      id="tags"
                      className=" filterSelect w-100 "
                      style={{
                        background: "#ddd",
                        border: "2px solid #ddd",
                        height: "40px",
                        borderRadius: "3px",
                        outline: "none",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {}}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCampain;
